import { createEventsService } from '@shared/api'
import { authorizedHttpClient } from './http-client'

export const EventsService = createEventsService(authorizedHttpClient, import.meta.env.VITE_API_URL)
